// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressVisualFull {
    display: flex;
    /* change the value if you want different thickness */
    height: 6px;
    margin-top: 22%;
  }
  
  .progressVisualPart {
    /* Number of the seconds for complete animation */
    transition: width 2s;
  }
  
  .progressLabel {
    /* Nothing here, move along */
    font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
      "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/loader/ProgressBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qDAAqD;IACrD,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iDAAiD;IACjD,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;IAC7B;wDACoD;EACtD","sourcesContent":[".progressVisualFull {\n    display: flex;\n    /* change the value if you want different thickness */\n    height: 6px;\n    margin-top: 22%;\n  }\n  \n  .progressVisualPart {\n    /* Number of the seconds for complete animation */\n    transition: width 2s;\n  }\n  \n  .progressLabel {\n    /* Nothing here, move along */\n    font-family: \"Lucida Sans\", \"Lucida Sans Regular\", \"Lucida Grande\",\n      \"Lucida Sans Unicode\", Geneva, Verdana, sans-serif;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
